import { SalesfloorRoom } from 'types/salesfloor';

export function encodeParticipantId(userId?: number, isPublic = false): string | null {
  if (!userId) return null;
  return `${isPublic ? 'public_user' : 'user'}_${userId}`;
}

export function hasWritePermission(room: SalesfloorRoom, userId: number): boolean {
  return room.ownerId === userId;
}
